import React, { Component } from 'react';
import LocalizedStrings from 'react-localization';
import URLSearchParams from '@ungap/url-search-params';
import { SetComponentLanguage, ApiRequest } from '../../helpers';
import Message from '../Common/Message/Message';
import TicketDistribution from '../TicketDistribution/TicketDistribution';
import en from './locales/en.json';
import fr from './locales/fr.json';
import './TicketDownload.css';

const strings = SetComponentLanguage(LocalizedStrings, en, fr);

class TicketDownload extends Component {
	constructor(props) {
        super(props);
        this.state = {  
            canDownload: true,
            canRefund: false,
            message: {
                title: '',
                content: '',
                type: ''
            },
            token: '',
            transaction_id: '',
        };
    }
    
    componentDidMount() {
        if(this.props.routeProps.location.search){
            let canRefund = false;
            const urlParams = new URLSearchParams(window.location.search);
            const refund = urlParams.get('refund');
            canRefund = refund === '1';
            this.setState({ 
                token: urlParams.get('token'),
                canRefund,
            }, () => {
                this.checkIfCanRefund();
            });
        } else {
            this.setMessage(window.general_strings.msg.oops, 'Your token is invalid', 'error');
            this.setState({ 
                canDownload: false,
                canRefund: false,
            });
        }
    }

    checkIfCanRefund = () => {
        const token = this.state.token;
        const doCheckRefundTransactionDetails = async (token) => {
            try {
                const checkRefundResponse = await checkRefundTransactionDetails(token);
                console.log('checkRefundResponse: ', checkRefundResponse);
                if (checkRefundResponse.data) {
                    this.setState({
                        canRefund: checkRefundResponse.data.can_refund,
                    });
                }
            } catch (error) {
                console.log(error);
            }
        }

        async function checkRefundTransactionDetails(token) {
            return await ApiRequest(`/transactions/customer-refund-detail`, {
                method: 'POST',
                data: {
                    token,
                }
			});
        }

        doCheckRefundTransactionDetails(token);
    }

    setMessage = (title, content, type) => {
        const message = {...this.state.message};
        message['title'] = title;
        message['content'] = content;
        message['type'] = type;
        this.setState({ message });
    }

    downloadTicket = () => {
        window.open(`${process.env.REACT_APP_SHOWTIX4U_API_HOST}/transactions/customer-tickets?token=${this.state.token}`);
    }

    refundTicket = () => {
        const token = this.state.token;
        const doRefund = async () => {
            try {
                const refundResponse = await refund(token);
                console.log(refundResponse);
                if(refundResponse.data){
                    if (refundResponse.data.error) {
                        this.setMessage(window.general_strings.msg.oops, refundResponse.data.error.message, 'error');
                    } else {
                        this.setMessage(window.general_strings.msg.yay, 'Your refund has been successful: ' + refundResponse.data.transaction_refund_id, 'success');
                    }
                }
            } catch (error) {
                console.log(error);
            }
        }

        async function refund(token) {
            return await ApiRequest(`/transactions/customer-refund`, {
                method: 'POST',
                data: {
                    token,
                }
			});
        }
        doRefund();
    }
	
    render() {
		return (
            <div className="showtix-section container">
                <div className="row">
                    <div className="col-12">
                        <Message
                            message={this.state.message}
                        />
                    </div>
                    <div className="col-12 col-sm-6">
                        <h1>{strings.title}</h1>
                        
                        <p className="showtix-subtitle">{strings.content2}</p>
                        <a className="showtix-button showtix-background__primary-2" target="_blank" href={`/electronic-ticket/${this.state.token}`}>
                            <span>{strings.etickets}</span>
                        </a>
    
                        <p className="showtix-subtitle mt-3">{strings.content}</p>
                        <button
                            className="showtix-button showtix-background__primary-2"
                            onClick={this.downloadTicket}
                            disabled={!this.state.canDownload}
                        >
                            <span>{strings.print}</span>
                        </button>

                    </div>
                    {this.state.canRefund && (
                        <div className="col-12 col-sm-6">
                            <div className="showtix-box">
                                <div className="showtix-padder">
                                    <h1>{strings.refundTitle}</h1>
                                    <p className="showtix-subtitle">{strings.refundContent}</p>
                                    <button
                                        className="showtix-button showtix-background__primary-2"
                                        onClick={this.refundTicket}
                                        disabled={!this.state.canRefund}
                                    >
                                        <span>{strings.refund}</span>
                                    </button>
                                </div>
                            </div>         
                        </div>
                    )}
                    {this.state.token !== '' && (
                        <TicketDistribution
                            token={this.state.token}
                            user={this.props.user}
                            isFromCheckout={false}
                        />
                    )}
                </div> 
            </div>     
		);
  	}
}

export default TicketDownload;



// WEBPACK FOOTER //
// ./src/components/TicketDownload/TicketDownload.js